import { combineReducers } from 'redux';
import { createSimpleRequestStatusReducer } from 'ContentData/helpers/reduxHelpers';
import { ECOMMERCE_CLEAR_OBJECTS_CACHE, ECOMMERCE_FETCH_OBJECT, ECOMMERCE_FETCH_OBJECTS, ECOMMERCE_FETCH_STORES, ECOMMERCE_SAVE_OBJECT_CACHE } from 'ContentData/actions/ActionTypes';
import { getEcommerceObjectFromCrmObject } from '../helpers/ecommerceHelpers';
import * as RequestStatus from 'ContentUtils/constants/RequestStatus';
const appStores = (state = {}, action) => {
  switch (action.type) {
    case ECOMMERCE_FETCH_STORES:
      {
        var _response$appStores;
        const {
          response
        } = action;
        if (!(response !== null && response !== void 0 && (_response$appStores = response.appStores) !== null && _response$appStores !== void 0 && _response$appStores.length)) return state;
        return response.appStores.reduce((acc, appStore) => {
          acc[appStore.appId] = appStore;
          return acc;
        }, {});
      }
    default:
      return state;
  }
};
const objectsCache = (state = {}, action) => {
  switch (action.type) {
    case ECOMMERCE_FETCH_OBJECTS:
      {
        const {
          response,
          options
        } = action;
        const {
          objectType
        } = options || {};
        if (!(response !== null && response !== void 0 && response.results) || !objectType) return state;
        const objectMap = state[objectType];
        const newObjectMap = response.results.reduce((acc, object) => {
          acc[object.hubSpotObjectId] = object;
          return acc;
        }, {});
        return Object.assign({}, state, {
          [objectType]: Object.assign({}, objectMap, newObjectMap)
        });
      }
    case ECOMMERCE_CLEAR_OBJECTS_CACHE:
      {
        const {
          objectType
        } = action;
        return Object.assign({}, state, {
          [objectType]: {}
        });
      }
    default:
      return state;
  }
};
const objects = (state = {}, action) => {
  switch (action.type) {
    case ECOMMERCE_FETCH_OBJECT:
      {
        const {
          response,
          options
        } = action;
        const {
          objectType
        } = options || {};
        if (!response || !objectType) return state;
        const currentObjects = state[objectType] || {};
        const ecommerceObject = getEcommerceObjectFromCrmObject(response, objectType);
        return ecommerceObject ? Object.assign({}, state, {
          [objectType]: Object.assign({}, currentObjects, {
            [ecommerceObject.hubSpotObjectId]: ecommerceObject
          })
        }) : state;
      }
    case ECOMMERCE_SAVE_OBJECT_CACHE:
      {
        const {
          objectType,
          object
        } = action;
        if (!objectType || !object) return state;
        const objectMap = state[objectType];
        return Object.assign({}, state, {
          [objectType]: Object.assign({}, objectMap, {
            [object.hubSpotObjectId]: object
          })
        });
      }
    default:
      return state;
  }
};
const objectsRequestStatus = (state = {}, action) => {
  switch (action.type) {
    case ECOMMERCE_FETCH_OBJECT:
      {
        const {
          options,
          response,
          error
        } = action;
        const {
          objectType,
          objectId
        } = options || {};
        if (!objectType || !objectId) return state;
        let newRequestStatus = RequestStatus.PENDING;
        if (response) newRequestStatus = RequestStatus.SUCCEEDED;
        if (error) newRequestStatus = RequestStatus.FAILED;
        const objectTypeState = state[objectType] || {};
        return Object.assign({}, state, {
          [objectType]: Object.assign({}, objectTypeState, {
            [objectId]: newRequestStatus
          })
        });
      }
    default:
      return state;
  }
};
export default combineReducers({
  appStores,
  requestStatus: createSimpleRequestStatusReducer(ECOMMERCE_FETCH_STORES),
  objectsRequestStatus,
  objectsCache,
  objects
});